import React from 'react';
import Hero from '../components/Sections/Hero';
import Features from '../components/Sections/Features';
import Services from '../components/Sections/Services';
import HowItWorks from '../components/Sections/HowItWorks';
import CTA from '../components/Sections/CTA';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <Features />
      <Services />
      <HowItWorks />
      <CTA />
    </div>
  );
};

export default Home;
